var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtruded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chips"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E8EC",
    d: "M298.796,383.998H0.13l10.672-42.672c0,0-10.672-63.998-10.672-149.325    c0-85.342,10.672-149.341,10.672-149.341L0.13,0.005h298.666L288.124,42.66c0,0,10.672,63.999,10.672,149.341    c0,85.327-10.672,149.325-10.672,149.325L298.796,383.998z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ED5564",
    d: "M10.802,341.326c0,0-10.672-63.998-10.672-149.325c0-85.342,10.672-149.341,10.672-149.341h277.322    c0,0,10.672,63.999,10.672,149.341c0,85.327-10.672,149.325-10.672,149.325H10.802z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M226.469,146.768c-27.453-8.094-37.624,33.046-76.999,37.64c-39.374-4.594-49.562-45.733-77.014-37.64   c-27.562,8.109-22.906,87.014,35.39,91.357c14.609,1.094,28.703-3.828,41.624-11.796c12.906,7.968,27,12.89,41.625,11.796   C249.391,233.781,254.031,154.877,226.469,146.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECD57",
    d: "M222.594,145.924L222.594,145.924c-24.625-3.344-35.671,34.108-73.124,38.483   c-39.374-4.594-49.562-45.733-77.014-37.64c-27.562,8.109-22.906,87.014,35.39,91.357c14.609,1.094,28.703-3.828,41.624-11.796   C195.392,198.36,222.594,145.924,222.594,145.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECD57",
    d: "M398.981,369.139c17.797-7.625,5.359-33.453,23.875-52.843c22.516-14.578,45.562,2.453,56.373-13.594   c10.859-16.125-25.593-55.233-57.842-32.343c-8.094,5.734-13.312,14.374-16.609,24.093c-10.156,1.422-19.625,4.938-26.766,11.812   C349.514,333.686,381.122,376.795,398.981,369.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M398.981,369.139c0.859-0.375,1.656-0.781,2.391-1.234l0,0c0,0-8.453-39.062,3.406-73.452   c-10.156,1.422-19.625,4.938-26.766,11.812C349.514,333.686,381.122,376.795,398.981,369.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M174.814,285.905c1.656,19.297,30.093,15.578,42.687,39.249c6.796,25.938-16.625,42.484-4.766,57.781   c11.906,15.374,60.467-6.984,48.843-44.781c-2.906-9.484-9.469-17.156-17.672-23.327c1.844-10.094,1.469-20.172-2.812-29.125   C223.985,250.047,173.142,266.547,174.814,285.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECD57",
    d: "M217.501,325.154c6.796,25.938-16.625,42.484-4.766,57.781c11.906,15.374,60.467-6.984,48.843-44.781   c-2.906-9.484-9.469-17.156-17.672-23.327c-28.921-22.047-68.655-26.266-68.67-26.266   C179.205,304.905,205.517,302.64,217.501,325.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA45",
    d: "M365.732,234.125c-19.172,2.781-13.812,30.938-36.718,44.891c-25.5,8.28-43.375-14.125-57.953-1.406   c-14.655,12.78,10.469,59.967,47.547,46.17c9.297-3.453,16.562-10.452,22.25-18.999c10.187,1.25,20.233,0.297,28.921-4.5   C404.372,281.141,384.95,231.344,365.732,234.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECD57",
    d: "M363.107,234.703c-16.094,4.906-12.297,31.047-34.093,44.312c-25.5,8.28-43.375-14.125-57.953-1.406   c-14.655,12.78,10.469,59.967,47.547,46.17c9.297-3.453,16.562-10.452,22.25-18.999   C361.201,274.625,363.107,234.703,363.107,234.703L363.107,234.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M149.471,373.326c-5.891,0-10.671,4.781-10.671,10.672h21.328   C160.127,378.107,155.361,373.326,149.471,373.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M106.8,373.326c-5.891,0-10.672,4.781-10.672,10.672h21.343C117.471,378.107,112.69,373.326,106.8,373.326z   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M64.128,373.326c-5.89,0-10.656,4.781-10.656,10.672H74.8C74.8,378.107,70.019,373.326,64.128,373.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M21.473,373.326c-5.891,0-10.671,4.781-10.671,10.672h21.328C32.129,378.107,27.364,373.326,21.473,373.326   z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M64.128,10.661c5.891,0,10.672-4.781,10.672-10.656H53.473C53.473,5.88,58.238,10.661,64.128,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M106.8,10.661c5.891,0,10.671-4.781,10.671-10.656H96.128C96.128,5.88,100.909,10.661,106.8,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M149.471,10.661c5.891,0,10.656-4.781,10.656-10.656h-21.328C138.799,5.88,143.58,10.661,149.471,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M192.126,10.661c5.891,0,10.672-4.781,10.672-10.656H181.47C181.47,5.88,186.236,10.661,192.126,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M234.797,10.661c5.891,0,10.671-4.781,10.671-10.656h-21.343C224.125,5.88,228.907,10.661,234.797,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M277.468,10.661c5.891,0,10.656-4.781,10.656-10.656h-21.327C266.797,5.88,271.577,10.661,277.468,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M21.473,10.661c5.891,0,10.656-4.781,10.656-10.656H10.802C10.802,5.88,15.583,10.661,21.473,10.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC92EA",
    d: "M149.471,298.655v32.14c0,73.952,44.296,137.545,107.811,165.716c-0.734,1.438-1.156,3.078-1.156,4.812   c0,5.891,4.781,10.672,10.672,10.672h127.997c5.891,0,10.672-4.781,10.672-10.672c0-1.781-0.438-3.438-1.203-4.922   c63.39-28.202,107.607-91.748,107.607-165.606v-32.14H149.471z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#FFFFFF",
    d: "M490.526,298.655v32.14c0,73.858-44.201,137.404-107.607,165.606   c0.766,1.484,1.203,3.141,1.203,4.922c0,5.891-4.766,10.672-10.656,10.672h21.328c5.891,0,10.672-4.781,10.672-10.672   c0-1.781-0.438-3.438-1.203-4.922c63.39-28.202,107.607-91.748,107.607-165.606v-32.14H490.526z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.473,192.001c0-85.342,10.656-149.341,10.656-149.341L21.473,0.005H0.13L10.802,42.66    c0,0-10.672,63.999-10.672,149.341c0,85.327,10.672,149.325,10.672,149.325L0.13,383.998h21.343l10.656-42.672    C32.129,341.326,21.473,277.328,21.473,192.001z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtruded);
export default __webpack_public_path__ + "static/media/extruded.601d638ec0cc9a8d9e938e78457ab714.svg";
export { ForwardRef as ReactComponent };